import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from "lodash";



@Component({
  selector: 'app-fidelity-order',
  templateUrl: './fidelity-order.component.html',
  styleUrls: ['./fidelity-order.component.css']
})
export class FidelityOrderComponent implements OnInit {
  innerHeight: number = window.innerHeight;

  fidelityProducts: any;
  clientFidelityPoint: any;
  clientFidelity: any;
  clientFidelityfirst: any
  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,

    public dialogRef: MatDialogRef<FidelityOrderComponent>,

  ) {
  
    this.fidelityProducts = data.clientBasket;
    this.clientFidelityPoint = data.clientFidelityPoint;

  }

  ngOnInit() {

    this.getClientFidelityPoints();
  }


  /**
  * @description Selectionne un produit avec de la fid
  */
  selecProductFid(item: any): void {
    let selected = !item.selected ? true : false;
    if (selected) {
      if (this.clientFidelity - item.fidelity_points >= 0) {
        this.clientFidelity -= item.fidelity_points;
        item.selected = selected;
      }
    }
    else {
      this.clientFidelity += item.fidelity_points;
      item.selected = selected;
    }

  }

  /**
  * @description retourne le nombre de point avec de la fid
  */
  getClientFidelityPoints() {
    let countTot = 0;

    this.fidelityProducts.map((det:any) => {
      if (det.free) {
        countTot += det.fidelity_points
      }
      else {
        det.selected = false;
      }


    });
    //min 0

    this.clientFidelity = (this.clientFidelityPoint - countTot) >= 0 ? this.clientFidelityPoint - countTot : 0;
    // this.clientFidelityfirst=  _.cloneDeep(this.clientFidelity);


    //tri array
    this.fidelityProducts.sort(function (a:any, b:any) { return a.fidelity_points < b.fidelity_points ? -1 : 1 });
    this.fidelityProducts.sort(function (a:any, b:any) { return a.free > b.free ? -1 : 1 });



  }



  validDial() {
    this.dialogRef.close({ basket: this.fidelityProducts });
  }

  closeDial() {
    this.dialogRef.close();
  }

}
